import type { APIRboConfig } from '@openx/types/deal.ts';

type LegacyRboConfig = APIRboConfig & {
  format?: string | null;
  industry?: string | null;
};

export const mapRboConfigFields = (rboConfig?: LegacyRboConfig | null): APIRboConfig | null => {
  if (!rboConfig) {
    return null;
  }

  const { format, industry, ...rest } = rboConfig;

  return {
    ...rest,
    channel: rboConfig.channel ?? format ?? null,
    target: rboConfig.target ?? industry ?? null,
  };
};
